import React, { useEffect, useState, useContext }from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import clientFunction from './clients.functions';
import notification from '../../components/notification.component';
import tableClientes from './cliente.table';
import DataTable from 'react-data-table-component';
import utils from '../../utils/utils.functions';
import { ConfigContextUtils } from '../../context/contextUtils.context';

const Clientes = () => {

  const { setPreloader } = useContext(ConfigContextUtils);

  const [modo, setModo] = useState('I');
  const [idMod, setModId] = useState(0);
  const [listado, setListado] = useState([]);
  const [listadofullx, setListaFull] = useState([]);
  const [pending, setPending] = useState(true);
  const { register, handleSubmit, reset, errors, watch } = useForm();
  const onSubmit = data => {
    setPreloader(true);
    if (modo === 'I') {
      clientFunction.register(data).then((response) => {
        if (response.status === 200) {
          if (response.data.cliente.error) {
            notification.warning(response.data.cliente.message);
          } else {
          listadoApi();
            notification.success();
            reset({
              rut: '',
              name: '',
              phone: '',
              email: '',
              email_confirm: '',
            });
          }
        }
        setPreloader(false);
      })
    } else {
      clientFunction.update({...data, id: idMod}).then((response) => {
        if (response.status === 200) {
          listadoApi();
          notification.success();
          reset({
            rut: '',
            name: '',
            phone: '',
            email: '',
            email_confirm: '',
          });
          setModId(0);
          setModo('I');
          setPreloader(false);
        }
      })
    }
  }

  const listadoApi = () => {
    clientFunction.listadoFull().then((lista) => {
      setListado(lista);
      setListaFull(lista);
      setPending(false);
    })
  }

  const selectionClient = (row) => {
    reset({
      ...row,
      email_confirm: row.email,
    });
    setModId(row.id);
    setModo('M');
  }

  const cancelOperation = () => {
    reset({});
    setModo('I');
  }

  useEffect(() => {
    listadoApi();
  },[])

  const removeRow = (status, id) => {
    clientFunction.activar({ active: status ? 0 : 1, id: id }).then((response) => {
      if (response.remove_cliente) {
        setListado(clientFunction.changeStatus(listado, id));
      }
    })
  }

  const buscador = (element) => {
    const resultado = utils.filterTable(listadofullx, element.target.value);
    setListado(resultado);
  }

  return (
  <>
    <Row>
      <Col lg={12}>
        <Card>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
                <div className="grupo-input">
                  <small>Rut</small>
                  <input type="text" className={`form-control input-border ${errors.rut && "is-invalid"}`} name="rut" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                  <small>Nombre completo</small>
                  <input type="text" className={`form-control input-border ${errors.name && "is-invalid"}`} name="name" ref={register({ required: true })} />
                </div>
                <div className="grupo-input">
                  <small>Telefono</small>
                  <input type="text" className={`form-control input-border ${errors.phone && "is-invalid"}`} name="phone" ref={register({ required: true })}/>
                </div>
                </Col>
                <Col>
                <div className="grupo-input">
                  <small>E-mail</small>
                  <input type="text" className={`form-control input-border ${errors.email && "is-invalid"}`} name="email" ref={register({ required: true })}/>
                </div>
                <div className="grupo-input">
                  <small>Confirmar e-mail</small>
                  <input type="text" className={`form-control input-border ${errors.email_confirm && "is-invalid"}`} name="email_confirm" ref={register({ required: true, validate: value => value === watch('email')})}/>
                </div>
                <div className="grupo-input mt-2">
                    { modo === 'I' ? 
                      <button type="submit" className="btnx btnx-warn">Registrar</button> 
                      : 
                      <button type="submit" className="btnx btnx-warn">Modificar</button>
                    }
                    {' '}<button onClick={cancelOperation} type="button" className="btnx btnx-warn">Cancelar</button>
                </div>
            </Col>
          </Row>
          </form>
        </Card>
      </Col>
    </Row>
    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
           <DataTable
            title="Listado clientes"
            customStyles={tableClientes.customStyles}
            columns={tableClientes.colummnsWithFunc(selectionClient, removeRow)}
            data={listado}
            dense={true}
            pagination={true}
            progressPending={pending}
            progressComponent={
              <h3>Cargando...</h3>
            }
            subHeader={true}
            subHeaderComponent={
              <div style={{ width: '40%' }}>
                <input onChange={(e) => buscador(e)} className="form-control" name="buscador" type="text" placeholder="Buscar cliente..."/>  
              </div>
            }
          />
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>
    </>
  )
}

export default Clientes;